import { render, staticRenderFns } from "./welcome-tcr.vue?vue&type=template&id=72d544d3&scoped=true&"
import script from "./welcome-tcr.vue?vue&type=script&lang=js&"
export * from "./welcome-tcr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d544d3",
  null
  
)

export default component.exports